module.exports = __webpack_public_path__ + "img/stackslash-process-7-mobile.3053f896.jpg";